import {getInstanceConfigValue} from "../utils";

/**
 * Returns "openai" or "gemini" based on instanceConfig
 * @param {Array} instanceConfig - Instance config array
 * @returns {"openai"|"gemini"}
 */
export function getAIProvider(instanceConfig) {
    const value = getInstanceConfigValue("supportbot", "ai", instanceConfig);
    return value === "gemini" ? "gemini" : "openai";
}
